(() => {
  'use strict';
  let bannerLoading;
  const loadBanner = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (!bannerLoading) bannerLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
    return bannerLoading;
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('.mj-cookie-settings');
    if (!link) return;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    try {
      await loadBanner();
      await window.privacyBanner.showPreferences();
    } catch {
      const status = document.querySelector('.toast');
      if (status) {
        status.textContent = link.dataset.error;
        status.classList.add('active');
        setTimeout(() => status.classList.remove('active'), 6000);
      }
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
